import store from "@/store/index.js";
import survey from "@/survey";
import i18n from "@/plugins/i18n";

export default {
	beforeRouteUpdate(to, from, next) {
		Promise.all([
			store.dispatch("fetchTenant", to.params.tenant),
			// Survey backend component needs to be refactored as a store module
			survey.loadSurvey(to.params.tenant),
		])
			.then(() => {
				document.title = store.state.tenant.metadata.prettyName;
				i18n.locale = to.params.lang;
				const languages = store.getters.languages;
				i18n.locale = languages.includes(to.params.lang) ? to.params.lang : languages[0];

				if (!languages.includes(to.params.lang))
					next({
						...to,
						params: { ...to.params, lang: i18n.locale },
						replace: true,
					});
				else next();
			})
			.catch((e) => {
				console.log(e);
				next({ name: "notfoundglobal" });
			});
	},
};
